<template>
  <div>
    <div class="h6 main" style="margin-bottom:1.5rem">스킨 수정요청</div>
    <div class="box" v-if="detail">
      <div class="columns">
        <div class="column is-5" style="padding-right: 30px">
          <div class="service-info">
            <div class="detail-title">서비스 정보</div>
            <div style="margin-bottom:80px">
              <div class="subtitle7 sub3">문의 유형</div>
              <div class="body4 main">{{ detail.category }}</div>
              <div class="subtitle7 sub3">상품종류</div>
              <div class="body4 main">플랫폼파이 스킨 ({{ detail.product_name }})</div>
              <div class="subtitle7 sub3">요청사항</div>
              <div class="body4 main">{{ detail.content }}</div>
              <div class="subtitle7 sub3">진행상황</div>
              <div class="body4 main">
                <div><span class="sub3" style="margin-right:6px">수정요청 확인중</span> {{ datesFormat(detail.created_time, 'date_time_2')  }}</div>
                <template v-for="(opt, idx) in option.slice(1)">
                  <div v-if="detail[`dt_${opt.value}`]" :key="`opt-status-${idx}`">
                    <span class="sub3" style="margin-right:6px">{{ opt.label }}</span> {{ datesFormat(detail[`dt_${opt.value}`], 'date_time_2')  }}</div>
                </template>
              </div>
            </div>
          </div>
          <div class="service-info">
            <div class="detail-title">견적 내용 / 상태 변경</div>
            <div class="subtitle7 sub3">상태</div>
            <select class="input-border" v-model="value.status" style="width:160px">
              <option v-for="(opt,idx) in option" :key="`opt-${idx}`"
                :value="opt.value">{{ opt.label }}</option>
            </select>
            <template v-if="value.status >= 1">
              <div class="subtitle7 sub3">견적내용</div>
              <div class="grid-est">
                <div class="body4 sub3">추가기능</div>
                <input class="input-border" type="text" v-model="value.estimate.feature"
                      @keyup="e => value.estimate.feature = e.target.value">
              </div>
              <div class="grid-est">
                <div class="body4 sub3">작업범위</div>
                <input class="input-border" type="text" v-model="value.estimate.arrange"
                       @keyup="e => value.estimate.arrange = e.target.value">
              </div>
              <div class="grid-est">
                <div class="body4 sub3">작업기간</div>
                <input class="input-border" type="text" v-model="value.estimate.period"
                       @keyup="e => value.estimate.period = e.target.value">
              </div>
              <div class="grid-est">
                <div class="body4 sub3">견적금액(원)</div>
                <input class="input-border" type="number" v-model.number="value.price">
              </div>
            </template>
          </div>
          <div class="flex-end" style="margin-top:32px">
            <button class="button is-primary" @click="clickSave">저장하기</button>
          </div>
        </div>
        <div class="column is-7" style="padding-left: 30px">
          <launch-talk :talkId="detail.talk" :talks.sync="talks"></launch-talk>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import LaunchTalk from "../../../module/common/LaunchTalk";
  export default {
    name: "SkinInquiryDetail",
    components: {LaunchTalk},
    created() {
      this.getData();
    },
    data() {
      return {
        detail: undefined,
        option: [
          {value: 0, label: '수정요청 확인중'},
          {value: 1, label: '수정요청 결제대기'},
          {value: 2, label: '수정요청 작업중'},
          {value: 3, label: '수정완료'},
          {value: 4, label: '완료 (런치톡 종료)'}
        ],
        value: {
          status: 0,
          estimate: {
            feature: '',
            arrange: '',
            period: ''
          },
          price: 0
        },
        talks: []
      }
    },
    methods: {
      getData() {
        this.$axios.get(`admin/launchpack/v1/skin_inquiry/${this.$route.query.id}`).then(res => {
          this.detail = res.data;
          this.value.status = this.detail.status;
          this.value.estimate = this.cloneItem(this.detail.estimate);
          this.value.price = this.detail.price;
        });
      },
      clickSave() {
        if(Object.keys(this.value.estimate).some(key => this.value.estimate[key].trim() === '')) {
          this.toast('견적내용을 정확히 입력해주세요.');
          return;
        }
        else if(this.value.price === 0) {
          this.toast('견적 금액을 입력해주세요.');
          return;
        }
        this.$axios.patch(`admin/launchpack/v1/skin_inquiry/${this.$route.query.id}`, this.value).then(res => {
          if(res.status === 200) {
            this.toast('저장되었습니다.');
            this.getData();
          }
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .detail-title
    color $main
    font-size 24px
    line-height 34px
    font-weight 500
    padding-bottom 16px
    border-bottom 1px solid $sub5
    margin-bottom 32px
  .service-info
    .subtitle7
      margin 24px 0 4px 0
    .subtitle7:first-child
      margin-top 0

  .box-estimate
    border 1px solid $gray1
    border-radius 12px
    padding 32px
    margin-bottom 40px
  .grid-est
    display grid
    grid-template-columns 80px 1fr
    grid-row-gap 10px
    margin 16px 0

  .lp-divider-gray2
    width 100%
    height 1px
    background-color $gray2
    margin-bottom 16px
  .button-est
    width 100%
    height 48px

  .status
    padding 4px 8px
    border-radius 4px
    font-size 13px
    font-weight 500
  .skin-status-0
    background-color $gray2
    color $sub2
  .skin-status-1
    background-color $error50
    color $error
  .skin-status-2
  .skin-status-3
  .skin-status-4
    background-color $subcolor50
    color $subcolor2

  .grid-est
    display grid
    grid-template-columns 80px 1fr
    grid-gap 12px
</style>
